import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=4ec7e253&scoped=true&"
import script from "./PlanItem.vue?vue&type=script&lang=js&"
export * from "./PlanItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=4ec7e253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7e253",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDivider,VImg,VSpacer})
